import './App.css';
import TraderPortfolio from './components/TraderPortfolio'

function App() {
  return (
   
   <TraderPortfolio />
  );
}

export default App;
